import React from 'react';
import { Users } from 'lucide-react';

const ParticipantCount = ({ participants, className = '' }) => {
  const count = participants.length;

  return (
    <div className={`flex items-center gap-2 px-3 py-1.5 rounded-lg glass-panel ${className}`}>
      <Users className="w-4 h-4 text-orange-400" />
      <div className="flex items-center gap-1.5">
        <span className="text-sm font-semibold text-zinc-600">{count}</span>
        <span className="text-xs text-zinc-400">
          participant{count !== 1 ? 's' : ''}
        </span>
      </div>

      {/* Visual indicator */}
      <div className="flex items-center gap-0.5 ml-1">
        {participants.map((participant, index) => (
          <div
            key={participant.id}
            className={`w-2 h-2 rounded-full ${
              index === 0 
                ? 'bg-blue-500' 
                : 'bg-orange-500'
            } ${count > 1 ? 'animate-pulse' : ''}`}
            title={participant.name}
          />
        ))}
      </div>
    </div>
  );
};

export default ParticipantCount;